import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { Device } from '../../../common/interfaces/item.interface';
import { CommandData, SharedProgrammingService, CommonProgrammingContext } from '../../../common/services/shared-programming.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';

import { MediaProgrammingContext } from '../quickstart-media.service';

@Component({
  templateUrl: './select-remote.component.html'
})
export class QSMediaSelectRemoteComponent extends BaseRoutingComponent {

  private _remotes: Observable<Device[]>;
  private _ready: Observable<boolean>;

  constructor(
    protected store: Store<{
      mediaProgramming: MediaProgrammingContext,
      sharedProgramming: CommonProgrammingContext
    }>,
    private _shared: SharedProgrammingService,
    public router: Router
  ) {
    super();
    this._remotes = this.store.select(s => s.mediaProgramming.remotes);
    this._ready = this._shared.isReady;
  }

  private _setAction(remote: Device) {
    let commandData: CommandData = {
      codeitemId: 0,
      deviceId: remote.id,
      command: 'BEEP:TIME',
      beforeCodeItemId: 0,
      parentCodeItemId: 0,
      creator: '',
      type: 1,
      params: [{
        name: 'TIME',
        value: 60
      }]
    }

    this._shared.saveAction(commandData);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-media/select-remote/select-remote.component.ts